import { Link } from "react-router-dom";
import three from "../assets/four.jpg";
import one from "../assets/one.jpg";
import two from "../assets/two.jpg";
import vexone from "../assets/vexone.png";
import vexthree from "../assets/vexthree.png";

export const Home = () => {
  return (
    <>
      <>
        <hr style={{ width: "100%", height: "4px" }} />
        <div className="flex items-center md:items-stretch justify-center pr-2 pl-2 pb-2 flex-col md:flex-row">
          <Link
            to="/opening"
            className="flex flex-col cursor-pointer w-auto md:w-1/3 rounded overflow-hidden shadow-lg  dark:shadow-slate-800 m-4"
          >
            <img
              className="w-full object-cover"
              src={vexone}
              alt="One"
              style={{ height: "255px" }}
            />
            <div className="flex flex-1 items-center md:px-6 md:py-4 px-4 py-2">
              <div className="dark:text-white font-bold text-xl">
                Opening & Closing Ceremonies
              </div>
            </div>
          </Link>
          <Link
            to="/red-hs"
            className="flex flex-col cursor-pointer w-auto md:w-1/3 rounded overflow-hidden shadow-lg  dark:shadow-slate-800 m-4"
          >
            <img
              className="w-full object-cover"
              src={two}
              alt="One"
              style={{ height: "255px" }}
            />
            <div className="flex flex-1 items-center md:px-6 md:py-4 px-4 py-2">
              <div className="dark:text-white font-bold text-xl">
                Red Division
              </div>
            </div>
          </Link>

          <Link
            to="/blue-hs"
            className="flex flex-col cursor-pointer w-auto md:w-1/3 rounded overflow-hidden shadow-lg  dark:shadow-slate-800 m-4"
          >
            <img
              className="w-full object-cover"
              src={one}
              alt="Two"
              style={{ height: "255px" }}
            />
            <div className="flex flex-1 items-center md:px-6 md:py-4 px-4 py-2">
              <div className="dark:text-white font-bold text-xl">
                Blue Division
              </div>
            </div>
          </Link>

          <Link
            to="/green-hs"
            className="flex flex-col cursor-pointer w-auto md:w-1/3  rounded overflow-hidden shadow-lg  dark:shadow-slate-800 m-4"
          >
            <img
              className="w-full object-cover"
              src={three}
              alt="Three"
              style={{ height: "255px" }}
            />
            <div className="flex flex-1 items-center md:px-6 md:py-4 px-4 py-2">
              <div className="dark:text-white font-bold text-xl">
                Green Division
              </div>
            </div>
          </Link>
          <Link
            to="/orange-hs"
            className="flex flex-col cursor-pointer w-auto md:w-1/3  rounded overflow-hidden shadow-lg  dark:shadow-slate-800 m-4"
          >
            <img
              className="w-full object-cover"
              src={vexthree}
              alt="Three"
              style={{ height: "255px" }}
            />
            <div className="flex flex-1 items-center md:px-6 md:py-4 px-4 py-2">
              <div className="dark:text-white font-bold text-xl">
                Orange Division
              </div>
            </div>
          </Link>
        </div>
      </>
    </>
  );
};
